import { useState, useEffect } from "react";
import { useColors } from "../ColorsContext";
import WristbandIcon from "../components/WristbandIcon";

export default function ScreenWelcome({ onNext }) {
  const C = useColors();
  const [pulse, setPulse] = useState(true);
  useEffect(() => {
    const t = setInterval(() => setPulse(p => !p), 800);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      onClick={onNext}
      style={{
        height: "100%", display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center", gap: 40, padding: 40,
        background: `radial-gradient(ellipse at center, ${C.navyMid} 0%, ${C.navy} 70%)`,
        cursor: "pointer",
      }}
    >
      {/* Logo */}
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 12, letterSpacing: 4, color: C.muted, textTransform: "uppercase", marginBottom: 12 }}>
          PURSUIT OCR
        </div>
        <div style={{ fontSize: 42, fontWeight: 900, color: C.white, fontFamily: "'Georgia', serif", letterSpacing: -1 }}>
          AUGMENTA
        </div>
        <div style={{ width: 60, height: 3, background: C.pink, margin: "14px auto 10px" }} />
        <div style={{ fontSize: 14, fontWeight: 500, fontStyle: "italic", color: "#E83E8C", letterSpacing: "0.08em" }}>
          Where Every Obstacle Has a Story
        </div>
      </div>

      {/* Pulsing CTA circle */}
      <div style={{ position: "relative", width: 200, height: 200, filter: `drop-shadow(0 0 32px ${C.pink}40)` }}>
        {/* Outer pulse ring */}
        <div style={{
          position: "absolute", inset: 0, borderRadius: "50%",
          border: `2px solid ${C.pink}`,
          transform: `scale(${pulse ? 1.12 : 1})`,
          opacity: pulse ? 0.25 : 0.55,
          transition: "all 0.8s ease",
        }} />
        {/* Inner pulse ring */}
        <div style={{
          position: "absolute", inset: 16, borderRadius: "50%",
          border: `2px solid ${C.teal}`,
          transform: `scale(${pulse ? 1 : 1.08})`,
          opacity: pulse ? 0.55 : 0.25,
          transition: "all 0.8s ease",
        }} />
        {/* Disk with CTA content */}
        <div style={{
          position: "absolute", inset: 32, borderRadius: "50%",
          background: C.navyMid,
          display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", gap: 6,
          border: `1px solid ${C.pink}30`,
        }}>
          <WristbandIcon size={36} color={C.pink} />
          <div style={{
            fontSize: 10, letterSpacing: 2.5, color: C.pink,
            fontWeight: 800, textTransform: "uppercase", textAlign: "center", lineHeight: 1.3,
          }}>
            SCAN<br />WRISTBAND
          </div>
          <div style={{ fontSize: 11, color: C.muted, fontWeight: 600 }}>
            TO BEGIN →
          </div>
        </div>
      </div>

      {/* Bottom hint */}
      <div style={{ color: C.light, fontSize: 11, display: "flex", alignItems: "center", gap: 8 }}>
        <WristbandIcon size={16} color={C.muted} />
        Tap anywhere on the screen
      </div>
    </div>
  );
}
